import { render, staticRenderFns } from "./invoice-exchange-detail.vue?vue&type=template&id=753d9665"
import script from "./invoice-exchange-detail.vue?vue&type=script&lang=js"
export * from "./invoice-exchange-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports